import React from 'react'

import { resolveCookieDomain } from '@affiliate-cabinet/rest'
import { Cookies } from '@affstore-ds/helpers'

import { AdvertiserLogo } from '../../../assets'
import {
  OnboardingToOfferConversionFunnelMapURLParametersType,
  OnboardingToOfferConversionFunnelParametersInterface,
  OnboardingToOfferConversionFunnelTrackedURLParametersType,
} from './OnboardingToOfferConversionFunnel.types'

const TRACKED_URL_PARAMS: OnboardingToOfferConversionFunnelTrackedURLParametersType[] = ['advertiser', 'model', 'program']

const COOKIES_PARAMS_OBJECT: Record<OnboardingToOfferConversionFunnelMapURLParametersType, OnboardingToOfferConversionFunnelMapURLParametersType> = {
  m_oto_advertiser: 'm_oto_advertiser',
  m_oto_model: 'm_oto_model',
  m_oto_program: 'm_oto_program',
}
const COOKIES_PARAMS: OnboardingToOfferConversionFunnelMapURLParametersType[] = Object.values(COOKIES_PARAMS_OBJECT)

const parameterToCookieMap: Record<OnboardingToOfferConversionFunnelTrackedURLParametersType, OnboardingToOfferConversionFunnelMapURLParametersType> =
  {
    advertiser: 'm_oto_advertiser',
    model: 'm_oto_model',
    program: 'm_oto_program',
  }

const COOKIE_EXPIRY = 86_400 * 30
const DELETE_COOKIE_EXPIRY = -99_999_999
const ADVERTISER_ALIASES_TO_LOGO: Record<string, React.ReactNode> = {
  '8xtrade': <AdvertiserLogo h="20px" iconName="Logo8xtrade" size="m" w="100%" />,
  '9expert': <AdvertiserLogo h="20px" iconName="Logo9expert" size="m" w="100%" />,
  assetise: <AdvertiserLogo h="20px" iconName="LogoAssetise" size="m" w="100%" />,
  avalon: <AdvertiserLogo h="20px" iconName="LogoAvalon" size="m" w="100%" />,
  broker10: <AdvertiserLogo h="20px" iconName="LogoBroker10" size="m" w="100%" />,
  bullex: <AdvertiserLogo h="20px" iconName="LogoBullex" size="m" w="100%" />,
  capital_bear: <AdvertiserLogo h="20px" iconName="LogoCapitalBear" size="m" w="100%" />,
  capitalbear: <AdvertiserLogo h="20px" iconName="LogoCapitalBear" size="m" w="100%" />,
  dayprofit: <AdvertiserLogo h="20px" iconName="LogoDayProfit" size="m" w="100%" />,
  exnova: <AdvertiserLogo h="20px" iconName="LogoExnova" size="m" w="100%" />,
  fxoption: <AdvertiserLogo h="20px" iconName="LogoFxOption" size="m" w="100%" />,
  invetra: <AdvertiserLogo h="20px" iconName="LogoInvetra" size="m" w="100%" />,
  iq_option: <AdvertiserLogo h="20px" iconName="LogoIQ" size="m" w="100%" />,
  iq_option_europe: <AdvertiserLogo h="20px" iconName="LogoIQ" size="m" w="100%" />,
  'iq-broker': <AdvertiserLogo h="20px" iconName="LogoIQBroker" size="m" w="100%" />,
  mangotrade: <AdvertiserLogo h="20px" iconName="LogoMangoTrade" size="m" w="100%" />,
  OPTGO: <AdvertiserLogo h="20px" iconName="LogoOptGo" size="m" w="100%" />,
  optinary: <AdvertiserLogo h="20px" iconName="LogoOptinary" size="m" w="100%" />,
  pixtrade: <AdvertiserLogo h="20px" iconName="LogoPIXTRADE" size="m" w="100%" />,
  qcm_eu: <AdvertiserLogo h="20px" iconName="LogoQCMAU" size="m" w="100%" />,
  'qcm-au': <AdvertiserLogo h="20px" iconName="LogoQCMAU" size="m" w="100%" />,
  'qcm-eu': <AdvertiserLogo h="20px" iconName="LogoQCMAU" size="m" w="100%" />,
  'qcm-global': <AdvertiserLogo h="20px" iconName="LogoQCMAU" size="m" w="100%" />,
  'qcm-global2': <AdvertiserLogo h="20px" iconName="LogoQCMAU" size="m" w="100%" />,
  quadcode: <AdvertiserLogo h="20px" iconName="LogoQuadcode" size="m" w="100%" />,
  'quadcode-b2b': <AdvertiserLogo h="20px" iconName="LogoQuadcode" size="m" w="100%" />,
  sabiotrade: <AdvertiserLogo h="20px" iconName="LogoSabioTrade" size="m" w="100%" />,
  xoption: <AdvertiserLogo h="20px" iconName="LogoXOption" size="m" w="100%" />,
  xq_trade: <AdvertiserLogo h="20px" iconName="LogoXqTrade" size="m" w="100%" />,
}

const ADVERTISER_ALIASES_TO_BRAND_NAME: Record<string, string> = {
  '8xtrade': '8xtrade',
  '9expert': '9expert',
  assetise: 'Assetise.io',
  avalon: 'Avalon',
  broker10: 'Broker10',
  bullex: 'Bullex',
  capital_bear: 'Capital Bear',
  capitalbear: 'Capital Bear',
  dayprofit: 'DayProfit',
  exnova: 'Exnova',
  fxoption: 'FxOption',
  invetra: 'Invetra',
  iq_option: 'IQ Option',
  iq_option_europe: 'IQ Option Europe',
  'iq-broker': 'IQ Broker',
  mangotrade: 'MangoTrade',
  OPTGO: 'OPTGO',
  optinary: 'OPTINARY',
  pixtrade: 'PIXTRADE',
  qcm_eu: 'Quadcode Markets EU',
  'qcm-au': 'Quadcode Markets AU',
  'qcm-eu': 'Quadcode Markets EU',
  'qcm-global': 'Quadcode Markets Global',
  'qcm-global2': 'Quadcode Markets Global',
  quadcode: 'Quadcode',
  'quadcode-b2b': 'Quadcode B2B White Label',
  sabiotrade: 'SabioTrade',
  xoption: 'X Option',
  xq_trade: 'XQ Trade',
}

const parametersToObject = (): OnboardingToOfferConversionFunnelParametersInterface => {
  const searchParametersString = window.location.search
  const searchParameters = new URLSearchParams(searchParametersString)
  const parametersEntries = searchParameters.entries()
  const result: OnboardingToOfferConversionFunnelParametersInterface = Object.create(null)

  for (const [key, value] of parametersEntries) {
    result[key] = value
  }

  return result
}

const filterAndRenameParameters = (
  parameters: OnboardingToOfferConversionFunnelParametersInterface,
): Map<OnboardingToOfferConversionFunnelMapURLParametersType, string> =>
  TRACKED_URL_PARAMS.reduce((accumulator, key) => {
    const value = parameters[key]

    if (String(value) !== 'undefined' && String(value) !== 'null') {
      const cookieKey = parameterToCookieMap[key] || key

      accumulator.set(cookieKey, value)
    }

    return accumulator
  }, new Map())

const parameters = parametersToObject()
const filteredParameters = filterAndRenameParameters(parameters)

export const OnboardingToOfferConversionFunnel = {
  ADVERTISER_ALIASES_TO_BRAND_NAME,
  ADVERTISER_ALIASES_TO_LOGO,
  clearCookies: () => {
    for (const key of COOKIES_PARAMS) {
      const value = filteredParameters.get(key)

      const cookieDomain = resolveCookieDomain()

      Cookies.setCookie(key, value || '', {
        domain: cookieDomain,
        expires: DELETE_COOKIE_EXPIRY,
      })
    }
  },
  COOKIES_PARAMS_OBJECT,
  getMarketingURLParametersFromCookies: () =>
    COOKIES_PARAMS.reduce((accumulator, key) => {
      const trackedParameterValue = Cookies.getCookie(key)

      if (trackedParameterValue) {
        accumulator.set(key, trackedParameterValue)
      }

      return accumulator
    }, new Map<OnboardingToOfferConversionFunnelMapURLParametersType, string>()),
  setMarketingURLParametersToCookies: () => {
    const cookieDomain = resolveCookieDomain()

    if (filteredParameters.size <= 0) {
      return
    }

    for (const key of COOKIES_PARAMS) {
      const value = filteredParameters.get(key)

      Cookies.setCookie(key, value || '', {
        domain: cookieDomain,
        expires: value ? COOKIE_EXPIRY : DELETE_COOKIE_EXPIRY,
      })
    }
  },
}
